import { useState, useRef } from "react"
import API from "../../api/api"


import { useMedia } from "../../hooks";
import { id } from "date-fns/locale";
import { InputField } from "../../components/form/InputField";

import { openPdfFromBase64, fileToBase64, stripDataUrlPrefix } from "./front.files.utils"


import { requestPlan, fullPlanDataExtractionForSimulatedMenuInWeb, fetchImageItself, downloadAllImages, downloadAllImagesAsZip } from "./diet.data.extractor";
import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";

/**
 * Component for the page of various little developments for testing and advanced operations
 * @returns 
 */
export function DevUtils() {


    return (
        <LeftSideMenu active="devUtils" >

            <div id="wrapper" className="dev-utils">
                <div className="container">
                    <h1> <span className="fa fa-gamepad"></span> Avanzado | Utilidades desarrollo </h1>
                    <TestUploadImage/>
                    <BuscadorMediaServerRemoto />
                    <DescargadorYAgregadorDePlanNutricional />
                </div>
            </div>
        </LeftSideMenu>)
}






export function TestUploadImage() {

    const userId = sessionStorage.getItem("userid");
    const { media } = useMedia(`/${userId}/`, "test")

    const apiClient = API.instance()



    const fileInputField = useRef();
    const folderInputRef = useRef()
    const idInputRef = useRef()

    //Image upload things
    const [imageDataUrl, setImageDataUrl] = useState(null);
    const [imageMetadata, setImageMetadata] = useState(null);
    const [uploadQuery, setUploadQuery] = useState({
        folder: null,
        id: null
    })


    const handleFileChange = (ev) => {
        const file = ev.target.files[0]
        if (!file) return;
        const reader = new FileReader();
        // Update preview state
        reader.onload = () => {
            const dataUrl = reader.result;
            // Create an Image object to extract metadata
            const img = new Image();

            img.onload = () => {
                setImageDataUrl(dataUrl);
                // You can extract other metadata from the `file` object too
                setImageMetadata({
                    width: img.width,
                    height: img.height,
                    type: file.type,
                    name: file.name,
                    size: file.size // in bytes
                });
            };

            img.src = dataUrl;

        };
        reader.readAsDataURL(file);
    }






    const handleGetImage = async (user, fileName) => {

        const finalURL = `${baseUrl}private/doctor/${encodeURIComponent(user)}/${encodeURIComponent(fileName)}`;

        const requestOptions = {
            method: "GET",
            credentials: "include",
            headers: {
                File: "filename",
                Token: sessionStorage.getItem("token"),
                Userid: sessionStorage.getItem("userid"),
                version: 999999,
                "Content-Type": "application/json",
            }
        };



        const resultGetImagen = await fetch(finalURL,
            requestOptions
        )

        console.log("RESULTADO PEDIR IMAGEN", resultGetImagen)

        if (resultGetImagen.ok) {
            const blobImg = await resultGetImagen.blob();
            console.log("actual content of img", blobImg)
            const url = URL.createObjectURL(blobImg);
            window.open(url, '_blank');
        }
        else {
            return null
        }





    }



    // const [querySearchImages, setQuerySearchImages] = useState(null)

    // const [foundFiles, setFoundFiles] = useState([])







    return (<form
        style={{
            display: "grid",
            gap: "1em"
        }}

        className="single-util"
    >


        <div
            style={{  padding: "1em", display: "grid", gap: "1em" }}
        >
            <h2> <span className="fa fa-upload"/> Testing de upload de Archivos</h2>


            {/* Image and preview de image */}
            {imageDataUrl &&
                <>
                    <img
                        src={imageDataUrl}
                        alt="Uploaded preview"
                        style={{ maxWidth: "300px", border: "1px solid #ccc" }}
                    />

                    <p> Metadata {JSON.stringify(imageMetadata)}</p>
                </>
            }



            <div style={{ display: "flex", gap: "1em", alignItems: "center" }}>
                <label>Folder  </label>
                <input type="text" style={{ padding: " 0.4em 1em" }}
                    onChange={(ev) => { setUploadQuery((prev) => { return { ...prev, ["folder"]: ev.target.value } }) }}
                    ref={folderInputRef} />
            </div>


            {/* Previewing wher to save stuff */}
            {uploadQuery?.folder && uploadQuery?.id &&
                <h4>Will attempt to upload to '{`/${uploadQuery.folder}/${uploadQuery.id}`}'</h4>
            }

            <div style={{ display: "flex", gap: "1em", alignItems: "center" }}>
                <label>Id  </label>
                <input type="text" style={{ padding: " 0.4em 1em" }}
                    onChange={(ev) => { setUploadQuery((prev) => { return { ...prev, ["id"]: ev.target.value } }) }}
                    ref={idInputRef} />
            </div>
            <input type="file" accept="*"
                ref={fileInputField}
                onChange={handleFileChange}
                style={{ padding: "1em" }}
            />




            <button type="button"
                style={{
                    width: "max-content",
                    padding: "0.4em 1em",
                    backgroundColor: "teal",
                    borderRadius: "12px",
                    color: "white"
                }}

                onClick={() => {
                    handleUpload(fileInputField?.current?.files?.[0], uploadQuery.folder, uploadQuery.id)

                }}> Upload</button>
        </div>





        {/* <h4> Other tests</h4> */}

        {/* {
            <img
                src={`data:image/png;base64,${obtenerImagen("doctor", userId, "94075.jpg")}`}
                alt="remote image si existe"
                style={{ maxWidth: "300px", border: "1px solid #ccc" }}
            />
        } */}

    </form >)





}




//Works as well (uploads file to a given directory in the backend)
const handleUpload = async (
    file,
    folder,
    id) => {


    if (!file) {
        alert("Please select a file first.");
        return;
    }


    const apiClient = API.instance()


    //Convert to base64 representation
    // const fileb64 = fileToBase64(file)
    const fileName = file.name
    const safeFileName = fileName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");


    let responseWithConversionJSON;


    //Si es un archivo de imagen funciona
    if (!file.name.endsWith(".pdf"))
        responseWithConversionJSON = await apiClient.createMediaSOSWithBase64(
            folder,
            id,
            file,
            safeFileName,
            false,
            "Image"
        )
    //Everything that is not an image is send as "video" type for some reason
    else
        responseWithConversionJSON = await apiClient.createMediaSOSWithBase64(
            folder,
            id,
            file,
            safeFileName,
            false,
            "Video"
        )
    // window.alert(`createMediaSOSWithBase64 : ${JSON.stringify(responseWithConversionJSON)}`)
    //Apparently the name is auto generated in the back xD
    console.log(`UPLOADED NAME: ${responseWithConversionJSON.data}`)



}






const BuscadorMediaServerRemoto = () => {


    const apiClient = API.instance()


    const [querySearchImages, setQuerySearchImages] = useState(null)

    const [foundFiles, setFoundFiles] = useState([])
    //Busca en carpetas del server de media y obtiene el listado de imágenes para mostrarlo en la página
    // Funciona !!
    const handleFindMedia = async (folder, resourceId) => {


        console.log(`Entering handleFindMedia ${folder}/${resourceId}`)


        const response = await apiClient.findMedia(folder, resourceId)
        // window.alert(`handleFindMedia : ${JSON.stringify(Object.keys(response))}`)

        console.log(`Searching media ${folder}/${resourceId}`)
        console.dir(response)



        const listFiles = []


        Object.entries(response).forEach(([fileName, base64dataOrSomething]) => {

            const cleanBase64 = base64dataOrSomething.replace(/^base64/, "");
            //get what type of file it is
            const type =
                ([".jpg", ".jpeg", ".png", ".svg"].some(ext =>
                    fileName.toLowerCase().endsWith(ext)
                )) ? "Image" :
                    ([".mp4"].some(ext =>
                        fileName.toLowerCase().endsWith(ext)
                    )) ? "Video" :
                        (["pdf"].some(ext =>
                            fileName.toLowerCase().endsWith(ext)
                        )) ? "Pdf" : "Unknown"


            listFiles.push({
                name: fileName,
                type,
                base64:
                    type === "Image"
                        ? `data:image/png;base64,${cleanBase64}`
                        : type === "Pdf"
                            ? `data:application/pdf;base64,${cleanBase64}`
                            : type === "Video"
                                ? `data:video/mp4;base64,${cleanBase64}`
                                : null,
                icon:
                    type === "Video"
                        ? <RandomIcon />
                        : type === "Pdf"
                            ? <PdfIcon />
                            : <IdkFileIcon />
            });


        })

        setFoundFiles(listFiles)
    }






    return (
        <section
        
         className="single-util"
        style={{ display: "grid", gap: "1em" }}>
        

            <h2> Buscador de media en server remoto</h2>
            <input type="text" placeholder="path completo a buscar"
                value={querySearchImages}
                onChange={(ev) => {
                    setQuerySearchImages(ev.target.value)
                }}
            />

            <button type="button"
                style={{ width: "max-content" }}

                onClick={
                    () => {

                        const actualSearch = querySearchImages.split("/")

                        // handleFindMedia("doctor", "685919276216e85294c81530")
                        console.log("Búsqueda en directorio", querySearchImages)
                        handleFindMedia(actualSearch[0], actualSearch.slice(1).join("/"))
                    }}
            > Find Media</button>


            <h3>🔍 Archivos encontrados en {querySearchImages} </h3>
            <div style={{ display: "flex" }}>
                {foundFiles.length > 0 ?
                    foundFiles.map((fileInfo) => {
                        return <div style={{ display: "grid", justifyItems: "center", gap: "1em" }}>

                            {fileInfo.type === "Image" ?
                                <>
                                    <img alt={fileInfo.name}
                                        src={fileInfo.base64}
                                        style={{ maxWidth: "200px" }} />
                                    <figcaption>{fileInfo.name}</figcaption>
                                </>
                                :
                                <>
                                    {fileInfo.icon}
                                    <figcaption onClick={() => {
                                        openPdfFromBase64(fileInfo.base64)
                                    }}>{fileInfo.name}</figcaption>
                                </>

                            }



                        </div>
                    })
                    :
                    <p> No se ha encontrado ningún archivo en la path especificada</p>
                }
            </div>

        </section>

    )
}




const DescargadorYAgregadorDePlanNutricional = () => {

    const apiClient = API.instance()
    const [recipeImages, setRecipeImages] = useState({})


    return (
        <section 
        className="single-util"
        style={{ display: "grid", gap: "1em" }}>

            <h2><span className="fa fa-download"></span>  Descargador Y Agregador de Plan Nutricional</h2>

            <button
                type="button"
                style={{ width: "max-content", margin: "0 auto", padding: "0.2em 1em" }}

                onClick={async (ev) => {
                    ev.preventDefault()

                    //Esto son las imágenes en formato URL
                    const dictionaryOfImages =
                        await fullPlanDataExtractionForSimulatedMenuInWeb()

                    const listOfImagesWithObjectUrls = {}
                    // //NOTE -  Iterate over all the images and fetch them
                    for (const [imageId, details] of Object.entries(dictionaryOfImages)) {

                        if (Object.keys(details).length === 0) {
                            console.log(`Will skip image with id ${imageId} | details ${JSON.stringify(details)}`)
                            continue
                        }

                        // FETCH IMAGES IN TWO SIZES
                        const { success: successFetchSmallImage, data: imageBlob256 } = await fetchImageItself(details?.["256"])
                        const { success: successFetchLargeImage, data: imageBlob1024 } = await fetchImageItself(details?.["1024"])

                        if (successFetchSmallImage && successFetchLargeImage && imageBlob256 && imageBlob1024) {

                            const imageObjectUrlSmall = URL.createObjectURL(imageBlob256)
                            const imageObjectUrlBig = URL.createObjectURL(imageBlob1024)

                            //Create final shape of fetched images data
                            listOfImagesWithObjectUrls[imageId] = {
                                id: imageId,
                                ...details,
                                objectURLSmall: imageObjectUrlSmall,
                                blobImageSmall: imageBlob256,

                                objectURLBig: imageObjectUrlBig,
                                blobImageBig: imageBlob1024,

                            }
                        }
                    }

                    console.log("list of images with Obj urls", listOfImagesWithObjectUrls)
                    console.log(`En total hay ${Object.keys(listOfImagesWithObjectUrls).length} imágenes`)

                    setRecipeImages(listOfImagesWithObjectUrls)
                }
                } >   Descargar y agregar todo el plan nutricional</button>



            <section
            style={{ display: "grid", gap: "1em" }}
            >
                {Object.keys(recipeImages).length > 0 && <h4> Recetas Obtenidas:</h4>}
                <div style={{
                    display: "grid", gridTemplateColumns: "repeat(3,250px)",
                    rowGap: "1em", margin: "0 auto",

                    overflowY: "scroll",
                    overflowX: "hidden",
                    maxHeight: "300px"
                }}>
                    {Object.entries(recipeImages)
                        .map(([id, imageData]) => {
                            return (<figure>
                                <img
                                    id={id}
                                    src={imageData.objectURLSmall ?? ""}
                                    style={{ maxWidth: "100%" }}

                                    alt={`Imagen de receta ${id}`} />
                                <figcaption style={{ textAlign: "center", wordBreak: "break-all", padding: "1em" }}>
                                    Recipe instance: {id} | filename: {imageData.filename} | size: {imageData.size} ext: {imageData.extension}
                                </figcaption>
                            </figure>)
                        })}
                </div>

                {
                    Object.keys(recipeImages).length > 0 &&
                    <button type="button"
                        style={{ width: "max-content", margin: "0 auto", padding: "0.2em 1em" }}
                        onClick={() => {
                            downloadAllImagesAsZip(Object.values(recipeImages))
                        }}> Descargar las imágenes en un ZIP</button>
                }
            </section>
        </section>
    )
}











const baseUrl = "https://backend.munchfit.app/";


async function obtenerImagen(folder, id, fileName) {

    var finalURL = `${baseUrl}private / ${folder} / ${id} / ${fileName}`;

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            Token: sessionStorage.getItem("token"),
            Userid: sessionStorage.getItem("userid"),
            version: 999999,
            "Content-Type": "application/json",
        }
    };


    const resultImagen = await fetch(finalURL,
        requestOptions
    )

    console.log("RESULTADO PEDIR IMAGEN", resultImagen)


    const imgBlob = resultImagen.blob()

    console.log("actual content of imagen",)
    try {

        const url = URL.createObjectURL(imgBlob);
        return url

    }
    catch (err) {

        console.error(`img blob ${finalURL} not ok`)
        return null

    }


}









// ✅ Funciona, al menos devuelve correctamente  Actualizar el campo urlimg de la tabla de nutricionistas:
async function actualizarTablaNutricionistas(id, fileName) {


    const requestOptions = {
        method: "POST",
        credentials: "include",
        headers: {
            Folder: "/doctor/" + id,
            Token: sessionStorage.getItem("token"),
            Userid: sessionStorage.getItem("userid"),
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            user_id: sessionStorage.getItem("userid"),
            token: sessionStorage.getItem("token"),
            android_id: 0,
            _id: id,
            file: fileName
        })
    };


    const resultUpdateImageDirectory = await fetch(`${baseUrl}webDoctors / updateImgDirectory`,
        requestOptions
    )

    console.log(` resultUpdateImageDirectory - ${JSON.stringify((await resultUpdateImageDirectory.json()))}`)

    // window.alert(`Actualizar tabla nutricionistas ${JSON.stringify(resultUpdateImageDirectory)} `)

}






function RandomIcon() {
    return (
        <svg version="1.1" width="256" height="256" viewBox="0 0 256 256">
            <g
                style={{
                    stroke: "none",
                    strokeWidth: 0,
                    strokeDasharray: "none",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 10,
                    fill: "none",
                    fillRule: "nonzero",
                    opacity: 1,
                }}
                transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
                <path
                    d="M 45 0 C 20.147 0 0 20.147 0 45 c 0 24.853 20.147 45 45 45 s 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z M 62.251 46.633 L 37.789 60.756 c -1.258 0.726 -2.829 -0.181 -2.829 -1.633 V 30.877 c 0 -1.452 1.572 -2.36 2.829 -1.634 l 24.461 14.123 C 63.508 44.092 63.508 45.907 62.251 46.633 z"
                    style={{
                        stroke: "none",
                        strokeWidth: 1,
                        fill: "rgb(0,0,0)",
                        fillRule: "nonzero",
                        opacity: 1,
                    }}
                    transform="matrix(1 0 0 1 0 0)"
                />
            </g>
        </svg>
    );
}


function PdfIcon() {
    return (
        <svg
            height="200px"
            width="200px"
            viewBox="0 0 512 512"
            fill="#000000"
            xmlns="http://www.w3.org/2000/svg"
        >
            <style>{`.st0 { fill: #000000; }`}</style>
            <g>
                <path
                    className="st0"
                    d="M347.746,346.204c-8.398-0.505-28.589,0.691-48.81,4.533c-11.697-11.839-21.826-26.753-29.34-39.053
          c24.078-69.232,8.829-88.91-11.697-88.91c-16.119,0-24.167,17.011-22.376,35.805c0.906,9.461,8.918,29.34,18.78,48.223
          c-6.05,15.912-16.847,42.806-27.564,62.269c-12.545,3.812-23.305,8.048-31.027,11.622c-38.465,17.888-41.556,41.773-33.552,51.894
          c15.197,19.226,47.576,2.638,80.066-55.468c22.243-6.325,51.508-14.752,54.146-14.752c0.304,0,0.721,0.097,1.204,0.253
          c16.215,14.298,35.366,30.67,51.128,32.825c22.808,3.136,35.791-13.406,34.891-23.692
          C382.703,361.461,376.691,347.942,347.746,346.204z M203.761,408.88c-9.401,11.178-24.606,21.9-29.972,18.334
          c-5.373-3.574-6.265-13.86,5.819-25.497c12.076-11.623,32.29-17.657,35.329-18.787c3.59-1.337,4.482,0,4.482,1.791
          C219.419,386.512,213.154,397.689,203.761,408.88z M244.923,258.571c-0.899-11.192,1.33-21.922,10.731-23.26
          c9.386-1.352,13.868,9.386,10.292,26.828c-3.582,17.464-5.38,29.08-7.164,30.44c-1.79,1.338-3.567-3.144-3.567-3.144
          C251.627,282.27,245.815,269.748,244.923,258.571z M248.505,363.697c4.912-8.064,17.442-40.702,17.442-40.702
          c2.683,4.926,23.699,29.956,23.699,29.956S257.438,360.123,248.505,363.697z M345.999,377.995
          c-13.414-1.768-36.221-17.895-36.221-17.895c-3.128-1.337,24.992-5.157,35.79-4.466c13.875,0.9,18.794,6.718,18.794,12.53
          C364.362,373.982,359.443,379.787,345.999,377.995z"
                />
                <path
                    className="st0"
                    d="M461.336,107.66l-98.34-98.348L353.683,0H340.5H139.946C92.593,0,54.069,38.532,54.069,85.901v6.57H41.353
          v102.733h12.716v230.904c0,47.361,38.525,85.893,85.878,85.893h244.808c47.368,0,85.893-38.532,85.893-85.893V130.155v-13.176
          L461.336,107.66z M384.754,480.193H139.946c-29.875,0-54.086-24.212-54.086-54.086V195.203h157.31V92.47H85.86v-6.57
          c0-29.882,24.211-54.102,54.086-54.102H332.89v60.894c0,24.888,20.191,45.065,45.079,45.065h60.886v288.349
          C438.855,455.982,414.636,480.193,384.754,480.193z"
                />
                <path
                    className="st0"
                    d="M109.418,137.706c1.212-1.092,1.798-2.645,1.798-4.749c0-2.096-0.587-3.649-1.798-4.741
          c-1.263-1.13-2.928-1.68-5.098-1.68h-5.975v12.848h5.975C106.489,139.385,108.155,138.836,109.418,137.706z"
                />
                <path
                    className="st0"
                    d="M156.139,157.481c1.13-0.424,2.103-1.107,2.973-2.088c0.944-1.055,1.538-2.571,1.769-4.511
          c0.26-2.208,0.386-5.091,0.386-8.569c0-3.485-0.126-6.369-0.386-8.569c-0.231-1.946-0.825-3.462-1.762-4.51
          c-0.869-0.982-1.873-1.679-2.972-2.089c-1.182-0.453-2.534-0.676-4.042-0.676h-7.164v31.68h7.164
          C153.605,158.15,154.965,157.927,156.139,157.481z"
                />
                <path
                    className="st0"
                    d="M214.269,137.981c0.84,0,1.523,0.684,1.523,1.524v6.48c0,0.84-0.683,1.524-1.523,1.524h-18.244v18.579
          c0,0.84-0.684,1.523-1.524,1.523h-7.209c-0.84,0-1.523-0.683-1.523-1.523v-47.554c0-0.839,0.683-1.524,1.523-1.524h27.653
          c0.839,0,1.524,0.684,1.524,1.524v6.48c0,0.84-0.684,1.524-1.524,1.524h-18.92v11.444H214.269z"
                />
            </g>
        </svg>
    );
}



function IdkFileIcon() {
    return (
        <svg width="24" height="24" strokeWidth="1.5" viewBox="0 0 24 24" fill="none" color="#000000">
            <path d="M12 8L12 12" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 16.01L12.01 15.9989" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 3H4V6" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 11V13" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 11V13" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 3H20V6" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 21H4V18" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 21H20V18" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
